'use strict';

var getScriptSource = (({
  src = '',
  extension = '',
  version = 'latest'
}) => {
  if (src) {
    return src;
  }

  return `https://cdn.ampproject.org/v0/${extension}-${version}.js`;
});

exports.default = getScriptSource;
//# sourceMappingURL=getScriptSource.js.map
